import { createSlice } from "@reduxjs/toolkit";
import { getUserList, signupUserThunk, userCheckoutThunk,
   getPaymentPlanThunk,getUserProfileThunk,getMyParticipatedContestsThunk, 
   getAdminStatThunk,
   getUserSubscribePlanThunk,
   getAdminRevenueThunk,
   getEventEarningThunk,
   getUserRewardsThunk
  } from "./thunk";


export const initialState = {
  users: [],
  error: null,
  userId: null,
  isLoading: false,
  isSuccess: false,
  paymentPlans: [],
  userProfileData:[],
  participatedContestList:[],
  adminDashboard:[],
  userSubscribePlanRevenue:[],
  specialEventRevenue:[],
  userRewards:[], //these are basically reward list of admin


  
};

const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetFlags: (state) => {
      state.isSuccess = false;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserList.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.users = [];
    });
    builder.addCase(getUserList.fulfilled, (state, action) => {
      if (action.payload && action.payload.success) {
        state.isLoading = false;
        state.users = action.payload.data;
      } else {
        state.isLoading = false;
        state.error = action.payload?.data || null;
      }
    });

    builder.addCase(getUserList.rejected, (state, action) => {
      state.isLoading = false;
    
      state.error = action.payload?.error || "Something went wrong";
    });

    // signup
    builder.addCase(signupUserThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.isSuccess=false
    });
    builder.addCase(signupUserThunk.fulfilled, (state, action) => {
    
      state.isLoading = false;
      state.isSuccess = true;
      state.userId = action.payload.id;
    });
    builder.addCase(signupUserThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.userId = null;
      state.error = action.payload || "Something went wrong";
    });

    // checkout User
    builder.addCase(userCheckoutThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(userCheckoutThunk.fulfilled, (state) => {
      state.isLoading = false;
      state.isSuccess = true;
    });
    builder.addCase(userCheckoutThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.userId = null;
      state.error = action.payload || "Something went wrong";
    });

    // Get Payment Plans
    builder.addCase(getPaymentPlanThunk.pending, (state) => {
      state.isLoading = true;
      state.paymentPlans = [];
      state.error = null;
    });
    builder.addCase(getPaymentPlanThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.paymentPlans = action.payload.data;
    });
    builder.addCase(getPaymentPlanThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.paymentPlans = [];
      state.error = action.payload || "Something went wrong";
    });


        // Get User Profile
    builder.addCase(getUserProfileThunk.pending, (state) => {
      state.userProfileData = [];
      state.error = null;
    });
    builder.addCase(getUserProfileThunk.fulfilled, (state, action) => {
      state.userProfileData = action.payload.data;
    });
    builder.addCase(getUserProfileThunk.rejected, (state, action) => {
      state.userProfileData = [];
      state.error = action.payload || "Something went wrong";
    });

          // Get Participated Contest List
    builder.addCase(getMyParticipatedContestsThunk.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(getMyParticipatedContestsThunk.fulfilled, (state, action) => {
      state.participatedContestList = action.payload.data;
      state.isLoading = false;
    });
    builder.addCase(getMyParticipatedContestsThunk.rejected, (state, action) => {
      state.participatedContestList = [];
      state.error = action.payload || "Something went wrong";
      state.isLoading = false;
    });


    // Get Admin Dashboard
    builder.addCase(getAdminStatThunk.pending, (state) => {
      state.par = [];
      state.error = null;
    });
    
    builder.addCase(getAdminStatThunk.fulfilled, (state, action) => {
      state.adminDashboard = action.payload.data;
    });

    builder.addCase(getAdminStatThunk.rejected, (state, action) => {
      state.adminDashboard = [];
      state.error = action.payload || "Something went wrong";
    });


      // Get User Subscribe Plan Revenue
    builder.addCase(getUserSubscribePlanThunk.pending, (state) => {
      state.par = [];
      state.error = null;
      state.isLoading = true;
    });
    
    builder.addCase(getUserSubscribePlanThunk.fulfilled, (state, action) => {
      state.userSubscribePlanRevenue = action.payload.data;
      state.isLoading = false;
    });

    builder.addCase(getUserSubscribePlanThunk.rejected, (state, action) => {
      state.userSubscribePlanRevenue = [];
      state.error = action.payload || "Something went wrong";
      state.isLoading = false;
    });

    // Get Admin Revenue
    builder.addCase(getAdminRevenueThunk.pending, (state) => {
      state.par = [];
      state.error = null;
      state.isLoading = true;
      state.userSubscribePlanRevenue=[]
    });
    
    builder.addCase(getAdminRevenueThunk.fulfilled, (state, action) => {
      state.userSubscribePlanRevenue = action.payload.data;
      state.isLoading = false;
    });

    builder.addCase(getAdminRevenueThunk.rejected, (state, action) => {
      state.userSubscribePlanRevenue = [];
      state.error = action.payload || "Something went wrong";
      state.isLoading = false;
    });

    // Get special event revenue
    builder.addCase(getEventEarningThunk.pending, (state) => {

      
      state.isLoading = true;
      state.specialEventRevenue=[]
    });
    
    builder.addCase(getEventEarningThunk.fulfilled, (state, action) => {
      state.specialEventRevenue = action.payload.data;
      // console.log("Special Event Revenue:", action.payload);
      state.isLoading = false;
    });

    builder.addCase(getEventEarningThunk.rejected, (state, action) => {
      state.specialEventRevenue = [];
      state.error = action.payload || "Something went wrong";
      state.isLoading = false;
    });


    // Get rewardlist for admin
    builder.addCase(getUserRewardsThunk.pending, (state) => {

      
      state.isLoading = true;
      state.userRewards=[]

    });
    
    builder.addCase(getUserRewardsThunk.fulfilled, (state, action) => {
      state.userRewards = action.payload.data;
      // console.log("User Rewards:", action.payload);
      state.isLoading = false;
    });

    builder.addCase(getUserRewardsThunk.rejected, (state, action) => {
      state.userRewards = [];
      state.error = action.payload || "Something went wrong";
      state.isLoading = false;
    });
  },
});

export const { resetFlags } = UserSlice.actions;
export default UserSlice.reducer;
